import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useStrategy } from "@/context/StrategyContext";
import { Panel, Avatar, Bar } from "./ui";

export default function LockedResults({ title = "Results are locked" }) {
  const { round, me } = useStrategy();
  const statuses = round?.statuses || {};
  return (
    <Panel className="p-8 sm:p-10 st-fade-in" data-testid="results-locked">
      <div className="flex items-start gap-5 flex-col sm:flex-row">
        <span className="grid place-items-center w-14 h-14 rounded-2xl shrink-0" style={{ background: "var(--st-lime-dim)" }}><Lock size={24} style={{ color: "var(--st-lime)" }} /></span>
        <div className="flex-1">
          <h3 className="text-xl font-extrabold">{title}</h3>
          <p className="st-muted text-sm mt-2 leading-relaxed max-w-xl">Each founder's answers stay private until all three have submitted. An administrator can reveal partial results from Rounds &amp; admin, or switch to the demo round to explore the dashboards with clearly-labelled demo data.</p>
          <div className="grid sm:grid-cols-3 gap-3 mt-6">
            {(round?.participants || []).map((p) => {
              const s = statuses[p.id] || {};
              return (
                <div key={p.id} className="st-panel-2 p-4" data-testid={`locked-status-${p.id}`}>
                  <div className="flex items-center gap-2 mb-3"><Avatar pid={p.id} size={26} /><span className="font-bold text-sm">{p.name}{p.id === me?.id ? " (you)" : ""}</span></div>
                  <Bar value={s.percent} />
                  <p className="st-faint text-xs mt-2">{s.status === "submitted" ? "Submitted" : s.status === "draft" ? `${s.percent}% complete` : "Not started"}</p>
                </div>
              );
            })}
          </div>
          <div className="flex gap-2 mt-6 flex-wrap">
            {statuses[me?.id]?.status !== "submitted" && <Link to="/roadmap/assess" className="st-btn st-btn-primary" data-testid="locked-continue">Continue my assessment</Link>}
            <Link to="/roadmap/admin" className="st-btn st-btn-ghost" data-testid="locked-admin">Rounds &amp; admin</Link>
          </div>
        </div>
      </div>
    </Panel>
  );
}
